export const SIGN_OUT = "SIGN_OUT";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const NEW_PAGE_DETAILS = "NEW_PAGE_DETAILS";
export const NEW_MENTOR_REQUEST = "NEW_MENTOR_REQUEST";
export const MENTOR_CHANGES = "MENTOR_CHANGES";
export const APPROVED_MECHANIC = "APPROVED_MECHANIC";
export const SET_CERTIFICATES_SERVICES_ARRAY =
  "SET_CERTIFICATES_SERVICES_ARRAY";
